import { Button } from '@dtx-company/design-system/src'
import { useFlowFeature } from '@dtx-company/inter-app/src/hooks/useFlowFeature/useFlowFeature'
import React, { useMemo } from 'react'
import useResendVerificationEmail from '../../hooks/useResendVerificationEmail'
import useTranslation from 'next-translate/useTranslation'

const ResendVerificationEmailButton: React.FC<{ additionalCallback?: () => unknown }> = ({
  additionalCallback
}) => {
  const { sendVerificationEmail } = useResendVerificationEmail()
  const { t } = useTranslation('email-verification')
  const [isEmailVerificationEnabled] = useFlowFeature('email-verification', {
    autoUpdate: true
  })

  const view = useMemo(() => {
    const button = (
      <Button
        color="primary"
        onClick={() => {
          sendVerificationEmail
          additionalCallback?.()
        }}
        loading={!sendVerificationEmail}
      >{`${t('views.ResendVerificationEmailButton')}`}</Button>
    )

    return isEmailVerificationEnabled ? button : null
  }, [additionalCallback, isEmailVerificationEnabled, sendVerificationEmail, t])

  return view
}

export default ResendVerificationEmailButton
